import React from 'react';
import {
  Alert,
  AlertDescription,
  AlertTitle,
  Button,
  Icon,
  Spacer,
  Text,
  useDisclosure,
  VStack,
} from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';
import AddInsuranceModalExtractionModal from '@advisory-report/src/features/creation-flow/components/insurance-policies/shared/modal/insurance-form/AddInsuranceModalExtractionModal';
import { InsurancePolicyType } from '@advisory-report/src/types/AdvisoryReport';
import useAuth from '../../../../../../../../../app/src/features/authentication/hooks/useAuth';
import DocExtractAcknowledgementModal from '@toolkit/src/features/document-extraction/components/acknowledgements/DocExtractAcknowledgementModal';

interface Props {
  type: InsurancePolicyType;
}
const AddInsuranceModalInsuranceExtractionAlert: React.FC<Props> = ({
  type,
}) => {
  const { ssoData } = useAuth();
  const { t } = useTranslation();
  const {
    isOpen: extractionModalIsOpen,
    onOpen: extractionModalonOpen,
    onClose: extractionModalonClose,
  } = useDisclosure();
  const {
    isOpen: acknowledgementIsOpen,
    onOpen: acknowledgementOnOpen,
    onClose: acknowledgementOnClose,
  } = useDisclosure();

  const handleClick = () => {
    if (ssoData.data?.metadata?.doc_extraction_acknowledgement) {
      extractionModalonOpen();
    } else {
      acknowledgementOnOpen();
    }
  };

  return (
    <>
      {acknowledgementIsOpen && (
        <DocExtractAcknowledgementModal
          isOpen={acknowledgementIsOpen}
          onAccept={() => {
            extractionModalonOpen();
            acknowledgementOnClose();
          }}
          onDecline={acknowledgementOnClose}
        />
      )}
      {extractionModalIsOpen && (
        <AddInsuranceModalExtractionModal
          type={type}
          isOpen={extractionModalIsOpen}
          onClose={extractionModalonClose}
        />
      )}
      <Alert variant="ai" alignItems="start">
        <Icon name="RiskAnalysisGeneralRiskAnalysis" />
        <VStack ml="3" align="flex-start">
          <AlertTitle>
            <Text textStyle="normalBodyMedium">
              {t('INSURANCE-POLICIES_MODAL_ALERT_DOC-EXTRACT_TITLE')}
            </Text>
          </AlertTitle>
          <AlertDescription>
            <Text textStyle="smallBody">
              {t('INSURANCE-POLICIES_MODAL_ALERT_DOC-EXTRACT_DESCRIPTION')}
            </Text>
          </AlertDescription>
        </VStack>
        <Spacer />
        <Button variant="ai" onClick={handleClick}>
          {t('INSURANCE-POLICIES_MODAL_ALERT_DOC-EXTRACT_BUTTON')}
        </Button>
      </Alert>
    </>
  );
};

export default AddInsuranceModalInsuranceExtractionAlert;
